import type { ApiEnvelope } from './types';

const API_BASE = import.meta.env.VITE_API_BASE ?? '/api';

function buildHeaders(extra?: HeadersInit): HeadersInit {
  const headers = new Headers(extra);
  headers.set('Accept', 'application/json');
  return headers;
}

async function readEnvelope<T>(response: Response): Promise<ApiEnvelope<T> | null> {
  try {
    return (await response.json()) as ApiEnvelope<T>;
  } catch {
    return null;
  }
}

async function handleResponse<T>(response: Response): Promise<T> {
  if (response.status === 204) {
    return undefined as T;
  }

  const body = await readEnvelope<T>(response);

  if (!response.ok || !body?.ok) {
    throw new Error(body?.error ?? `Request failed with ${response.status}`);
  }

  if (body.data === undefined) {
    throw new Error('API response did not include data');
  }

  return body.data;
}

export async function apiGet<T>(path: string): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: 'same-origin',
    headers: buildHeaders()
  });

  return handleResponse<T>(response);
}

export async function apiSend<T>(path: string, method: 'POST' | 'PUT' | 'PATCH' | 'DELETE', body?: unknown): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, {
    method,
    credentials: 'same-origin',
    headers: buildHeaders(body === undefined ? undefined : { 'Content-Type': 'application/json' }),
    body: body === undefined ? undefined : JSON.stringify(body)
  });

  return handleResponse<T>(response);
}

export const authLoginUrl = `${API_BASE}/auth/discord`;
